module.exports = __webpack_public_path__ + "img/simply-southern-logo.d2685dc5.jpg";